import AbstractFortnoxIntegration from "./AbstractFortnoxIntegration.js";

/**
 * `fortnoxIntegration` is an implementation of `AbstractNewIntegration`
 * for integration with Fortnox.
 */
export default class FortnoxExtendedIntegration extends AbstractFortnoxIntegration {
	getName() {
		return "Fortnox Extended";
	}

	routeName() {
		return "fortnox-extended";
	}

	importQuery() {
		return { useExtended: true };
	}

	isFortnoxExtendedIntegration() {
		return true;
	}

	canHaveLinkedDocuments() {
		return true;
	}

	canBeDisconnected() {
		return true;
	}

	hasInvoiceSupport() {
		return true;
	}

	static getType() {
		return "FortnoxExtendedIntegration";
	}
}
